import { configureStore, combineReducers } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { api } from './services/api';
import userInfoSlice from './reducers/userInfo/slice';
import myBrandSlice from './reducers/myBrand/slice';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['userInfo', 'myBrand'],
};

const rootReducer = combineReducers({
  [api.reducerPath]: api.reducer,
  userInfo: userInfoSlice,
  myBrand: myBrandSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(api.middleware),
});

export const persistor = persistStore(store);
